import { useDispatch, useStore } from "react-redux";
import { login, userInfo } from "./api";
import Store from "../store/index";
import { setUserInfo } from "../store/reducers/user";

export default class Auth {
  contstructor() {
    // dispatcher
  }

  // Login
  async login(email: string = "", password: string = "") {
    try {
      const { token } = await login(email, password);
      await Auth.setToken(token);
      await this.updateUserInfo();
    } catch (e) {
      throw e;
    }
  }
  // Logout
  async logout() {
    try {
      await Auth.clearToken();
      await this.updateUserInfo();
    } catch (e) {
      throw e;
    }
  }
  // Refresh Token
  refreshToken() {}
  // Set token
  static async setToken(token: string) {
    const prefix = "Bearer ";
    await localStorage.setItem("token", prefix + token);
  }
  // Clear token
  static async clearToken() {
    await localStorage.removeItem("token");
  }
  async updateUserInfo() {
    try {
      const data = await userInfo();
      Store.dispatch(setUserInfo(data));
    } catch (e) {
      Store.dispatch(setUserInfo({}));
    }
  }
}
